import React__default from 'react';
import DatamartLogo from './assets/svg/datamartLogo.js';

function DmLoader(props) {
  var loader = props.loader,
    className = props.className,
    style = props.style;
  if (loader === 'datamart-logo') return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(className, " dm-loader-spinner"),
    style: style
  }, /*#__PURE__*/React__default.createElement(DatamartLogo, null));else {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(className, " dm-loader-spinner"),
      style: style
    }, /*#__PURE__*/React__default.createElement(DatamartLogo, null));
  }
}
DmLoader.defaultProps = {
  loader: 'datamart-logo'
};

export { DmLoader };
